import { render } from "./Vitals.vue?vue&type=template&id=4cd8fd79&scoped=true"
import script from "./Vitals.vue?vue&type=script&lang=js"
export * from "./Vitals.vue?vue&type=script&lang=js"

import "./Vitals.vue?vue&type=style&index=0&id=4cd8fd79&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd8fd79"]])

export default __exports__